import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import PlainIcon, { iconType, iconColor } from 'app/common/ui-next/plain-icon'
import ControlsBar from 'app/common/ui-next/controls-bar'
import { EditProductionTypeModal } from './EditProductionTypeModal'
import { DeleteProductionTypeModal } from './DeleteProductionTypeModal'


type Props = {
  saleTypeId: string
}

export const SingleProdictionIcons = ({ saleTypeId }: Props) => {
  return (
    <ControlsBar right>
      <EditProductionTypeModal saleTypeId={saleTypeId}>
        {toggle => (
          <PlainButtonAsLink onClick={toggle}>
            <PlainIcon
              type={iconType.GEAR_LIGHT}
              color={iconColor.COLOR_DARKGRAY}
              width={20}
              height={20}
            />
          </PlainButtonAsLink>
        )}
      </EditProductionTypeModal>
      <DeleteProductionTypeModal saleTypeId={saleTypeId}>
        {toggle => (
          <PlainButtonAsLink onClick={toggle}>
            <PlainIcon
              type={iconType.LIGHT_CROSS}
              color={iconColor.COLOR_DARKGRAY}
              width={14}
              height="auto"
            />
          </PlainButtonAsLink>
        )}
      </DeleteProductionTypeModal>
    </ControlsBar>
  )
}
